var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer",class:{ fixed: _vm.isFixed }},[_c('div',{staticClass:"content"},[_c('span',{on:{"click":_vm.gorecord}},[_c('b',[_vm._v("Copyright")]),_vm._v("  ©2026  驰腾商城   版权所有        粤ICP备123037471号 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }